import findAndContactImage from '@/assets/img/pro-find-and-contact.png';
import getTheAppImage from '@/assets/img/pro-get-the-app.png';
import monitorImage from '@/assets/img/pro-monitor.png';
import remoteConnectImage from '@/assets/img/pro-remote-connection.png';
import { ConfigurableBrandList } from '@/pages/WorksWith/components/ConfigurableBrandList';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import locale from '../locale';

export const useCarousel = () => {
  const intl = useIntl();

  const slides = useMemo(
    () =>
      [
        {
          image: remoteConnectImage,
          title: locale['slide.pro.title.remote-connection'],
          text: locale['slide.pro.text.remote-connection'],
        },
        {
          image: monitorImage,
          title: locale['slide.pro.title.monitor'],
          text: locale['slide.pro.text.monitor'],
        },
        {
          image: findAndContactImage,
          title: locale['slide.pro.title.find-and-contact'],
          text: locale['slide.pro.text.find-and-contact'],
        },
        {
          image: getTheAppImage,
          title: locale['slide.pro.title.get-the-app'],
          text: locale['slide.pro.text.get-the-app'],
        },
        {
          imageComponent: <ConfigurableBrandList isCompact />,
          title: locale['slide.title.works-with'],
          text: locale['slide.text.works-with-simple'],
          alt: locale['slide.alt.works-with.alt'],
          buttonText: locale['slide.button.works-with'],
          isWorksWith: true,
        },
      ].map(slide => ({
        ...slide,
        title: slide.title
          ? intl.formatMessage({ id: slide.title.id, defaultMessage: slide.title.defaultMessage })
          : undefined,
        text: slide.text
          ? intl.formatMessage({ id: slide.text.id, defaultMessage: slide.text.defaultMessage })
          : undefined,
        alt: slide.alt ? intl.formatMessage({ id: slide.alt.id, defaultMessage: slide.alt.defaultMessage }) : undefined,
        buttonText: slide.buttonText
          ? intl.formatMessage({ id: slide.buttonText.id, defaultMessage: slide.buttonText.defaultMessage })
          : undefined,
      })),
    [intl],
  );

  return slides;
};
